import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type Platform = 'instagram' | 'tiktok' | 'youtube';

export interface SocialMediaAccount {
  platform: Platform;
  connected: boolean;
  username?: string;
  connectedAt?: string;
}

interface SocialMediaStore {
  accounts: SocialMediaAccount[];
  selectedPlatform: Platform | null;
  connectAccount: (platform: Platform) => void;
  disconnectAccount: (platform: Platform) => void;
  getSelectedPlatform: () => Platform | null;
}

export const useSocialMediaStore = create<SocialMediaStore>()(
  persist(
    (set, get) => ({
      accounts: [
        { platform: 'instagram', connected: false },
        { platform: 'tiktok', connected: false },
        { platform: 'youtube', connected: false }
      ],
      selectedPlatform: null,
      connectAccount: (platform) =>
        set((state) => ({
          accounts: state.accounts.map((account) =>
            account.platform === platform
              ? {
                  ...account,
                  connected: true,
                  connectedAt: new Date().toISOString(),
                  username: `demo_${platform}_user`
                }
              : account
          ),
          selectedPlatform: platform
        })),
      disconnectAccount: (platform) =>
        set((state) => ({
          accounts: state.accounts.map((account) =>
            account.platform === platform
              ? { ...account, connected: false, username: undefined, connectedAt: undefined }
              : account
          ),
          selectedPlatform: state.selectedPlatform === platform ? null : state.selectedPlatform
        })),
      getSelectedPlatform: () => get().selectedPlatform
    }),
    {
      name: 'social-media-storage',
      storage: createJSONStorage(() => localStorage),
      version: 1,
      migrate: (persistedState: any, version: number) => {
        if (version === 0) {
          return {
            ...persistedState,
            accounts: [
              { platform: 'instagram', connected: false },
              { platform: 'tiktok', connected: false },
              { platform: 'youtube', connected: false }
            ],
            selectedPlatform: null
          };
        }
        return persistedState;
      }
    }
  )
);